var ko = require('knockout');
require('knockout-postbox');

function SubmitButton(params) {
  this.buttonText = params.buttonText;
}

SubmitButton.prototype.submit = function() {
  ko.postbox.publish('loadingIndicator', true);
  return true;
};

module.exports = SubmitButton;
